import React, { useState, useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function Navbar() {
  const { t, lang, toggleLang } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="navbar-brand">
          <span className="scan">Scan</span>
          <span className="eat" style={{color:'#ffd800'}}>Eat</span>
        </div>

        <button className="mobile-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? '\u2715' : '\u2630'}
        </button>

        <ul className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <li><a onClick={() => scrollTo('hero')}>{t('nav.home')}</a></li>
          <li><a onClick={() => scrollTo('solutions')}>{t('nav.solutions')}</a></li>
          <li><a onClick={() => scrollTo('about')}>{t('nav.about')}</a></li>
          <li><a onClick={() => scrollTo('contact')}>{t('nav.contact')}</a></li>
          <li>
            <button className="lang-btn" onClick={toggleLang}>
              {lang === 'fr' ? 'EN' : 'FR'}
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
}
